import { TabRoute } from '@/navigation/types/navigation';
import type { AppTheme } from '@/styles/theme';

// The light pills are tinted down over the white bar; in dark mode the same
// alpha would sink them into the near-black bar, so there they stay opaque.
const LIGHT_HIGHLIGHT_ALPHA = 0.5;

export const TAB_HIGHLIGHTS: Partial<Record<string, keyof AppTheme['colors']>> =
  {
    [TabRoute.Radio]: 'tertiaryContainer',
    [TabRoute.Region]: 'regionContainer'
  };

// regionContainer only reaches 3.8:1 against the dark primary label, so the
// second pill switches to primaryContainer in dark mode.
export const DARK_TAB_HIGHLIGHTS: Partial<
  Record<string, keyof AppTheme['colors']>
> = {
  ...TAB_HIGHLIGHTS,
  [TabRoute.Region]: 'primaryContainer'
};

const ALPHA_SUFFIX = Math.round(LIGHT_HIGHLIGHT_ALPHA * 255)
  .toString(16)
  .padStart(2, '0');

export const highlightColor = (
  theme: AppTheme,
  token: keyof AppTheme['colors']
): string => {
  const value = theme.colors[token] as string;

  return theme.dark ? value : `${value}${ALPHA_SUFFIX}`;
};
